import React from "react";

type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  text?: string;
  center?: boolean;
  className?: string;
};

export const PageHeader: React.FC<PageHeaderProps> = ({
  eyebrow,
  title,
  text,
  center = true,
  className = "",
}) => {
  return (
    <header
      className={`${
        center ? "text-center" : ""
      } max-w-3xl mx-auto mb-16 ${className}`}
    >
      {eyebrow && (
        <div className="mb-2 text-sm font-semibold uppercase tracking-[0.14em] text-white/60">
          {eyebrow}
        </div>
      )}
      <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 font-display">
        {title}
      </h1>
      {text && (
        <p className="text-white/70 text-lg leading-relaxed max-w-3xl mx-auto">
          {text}
        </p>
      )}
    </header>
  );
};
